<app-core-offcanvas
  [headerTitle]="('price-info.price-info' | translate) + header"
  (closed)="onOffCanvasClosed()"
  width="100%"
  #createPriceInfoCanvas
  (chooseOn)="updatedId ? update() : save()"
  [saveText]="(updatedId ? 'common.update' : 'common.save') | translate"
  [showSaveButton]="isBecomeCase ? false : true"
  style="overflow: scroll"
  [showThirdButton]="updatedId ? true : false"
  [thirdButtonText]="
    !isBecomeCase
      ? ('price-info.send-to-case' | translate)
      : caseNo + ' nolu ' + ('price-info.go-to-case' | translate)
  "
  (chooseThirdButton)="!isBecomeCase ? saveRequestForCase() : goCase()"
>
<div class="instituation-container">
  <div class="row" >
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12 mb-2">

        <app-cards [title]="'price-info.general-info' | translate" footerDivider="border-0 pb-0 " class="custom-cardbox-area">
          <div bodyContent class="row">
            <form [formGroup]="filterForm">
              <!-- Tarih ve Vaka Tipi -->
              <div class="row mb-3">
                <div class="col-xl-6 col-sm-12">
                  <label for="date" class="form-label">
                    {{ "price-info.date" | translate }} <span class="text-danger">*</span>
                  </label>
                  <p-calendar formControlName="date" [placeholder]="'price-info.date-placeholder' | translate"
                    [showTime]="false" [showButtonBar]="true" appendTo="body" #date></p-calendar>
                  <div *ngIf="filterForm.get('date')?.invalid && filterForm.get('date')?.touched" class="text-danger">
                    <small *ngIf="filterForm.get('date')?.errors?.['required']">
                      {{ "validation.required" | translate }}
                    </small>
                  </div>
                </div>
        
                <div class="col-xl-6 col-sm-12">
                  <label for="caseType" class="form-label">
                    {{ "price-info.case-type" | translate }} <span class="text-danger">*</span>
                  </label>
                  <p-dropdown [options]="caseTypes" type="single" response="value" formControlName="caseType" [filter]="true"
                    [placeholder]="'price-info.case-type-placeholder' | translate"
                    (onChange)="onCaseTypeSelected($event.value)"></p-dropdown>
                  <div *ngIf="filterForm.get('caseType')?.invalid && filterForm.get('caseType')?.touched" class="text-danger">
                    <small *ngIf="filterForm.get('caseType')?.errors?.['required']">
                      {{ "validation.required" | translate }}
                    </small>
                  </div>
                </div>
              </div>
        
              <!-- Fiyat Tipi -->
              <div class="row mb-3">
                <div class="col-xl-12 col-sm-12">
                  <label for="priceType" class="form-label">
                    {{ "price-info.price-type" | translate }} <span class="text-danger">*</span>
                  </label>
                  <p-dropdown [options]="priceTypes" type="single" response="value" formControlName="priceType" [filter]="true"
                    [placeholder]="'price-info.price-type-placeholder' | translate"></p-dropdown>
                  <div *ngIf="filterForm.get('priceType')?.invalid && filterForm.get('priceType')?.touched" class="text-danger">
                    <small *ngIf="filterForm.get('priceType')?.errors?.['required']">
                      {{ "validation.required" | translate }}
                    </small>
                  </div>
                </div>
              </div>
            </form>
            <div *ngIf="priceInfoShowAddress" class="accordion accordion-danger-solid" id="accordion-two">
              <div class="accordion-item">
                <button
                  class="accordion-header rounded-lg d-flex align-items-center w-100"
                  id="accord-2One"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse2One"
                  aria-controls="collapse2One"
                  aria-expanded="true"
                  type="button"
                >
                  <span class="accordion-header-text">{{ "price-info.addresses" | translate }}</span>
                  <span class="accordion-header-indicator"></span>
              </button>
        
                <div id="collapse2One" class="collapse accordion__body show" aria-labelledby="accord-2One"
                  data-bs-parent="#accordion-two">
                  <div class="row p-3">
                    <div class="col-xl-12 col-sm-12 mb-3">
                      <core-address-input [form]="addressForm" (openModal)="openAddressModal('from')" [showMapButton]="true"
                        [label]="'price-info.from-address-title' | translate"
                        [addressFormName]="'fromAddress'"></core-address-input>
                    </div>
                    <div class="col-xl-12 col-sm-12">
                      <core-address-input [form]="addressForm" (openModal)="openAddressModal('to')" [showMapButton]="true"
                        [label]="'price-info.to-address-title' | translate"
                        [addressFormName]="'toAddress'"></core-address-input>
                    </div>
                  </div>
        
                  <div class="row p-3">
                    <div class="col-xl-12 col-sm-12">
                      <div class="row">
                        <div class="col-md-4 col-12">
                          <p *ngIf="regionNumber !== null" class="red-text">
                            <strong>{{ "price-info.region" | translate }}: </strong><span>{{ regionNumber }}</span>
                          </p>
                        </div>
                        <div class="col-md-1 col-12" style="border-right: 1px solid rgb(116, 112, 112)"></div>
                        <div class="col-md-7 col-12">
                          <p *ngIf="isBrigdePass !== null" class="red-text">
                            <strong>{{ "price-info.bridge-pass" | translate }}: </strong>
                            <span>
                              {{ (isBrigdePass === true ? "price-info.exist" : "price-info.not-exist") | translate }}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-8 col-sm-12">
                      <p *ngIf="description !== null" class="red-text">
                        <strong>{{ "price-info.description" | translate }}: </strong><span>{{ description }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </app-cards>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 mb-2">

        <app-cards [title]="'price-info.services-info' | translate" footerDivider="border-0 pb-0 "
          class="custom-cardbox-area">
          <div bodyContent class="row">
            <div headerRight class="text-end">
              <button class="btn btn-primary ms-2 mb-3" (click)="addService()">
                {{ "price-info.add-service" | translate }}
              </button>
            </div>

            <div class="card" style="border: none; background: transparent;">
                <div *ngIf="services?.length === 0" class="no-data-container">
                    <div class="no-data-icon">
                        <i class="fas fa-clipboard-list"></i>
                    </div>
                    <p class="no-data-text">
                        Henüz eklenmiş bir hizmet bulunmamaktadır.
                    </p>
                </div>

                <!-- Services List -->
                <div *ngIf="services.length > 0">
                    <div *ngFor="let item of services; let i = index" class="service-card">
                        <div class="service-header">
                            <h3 class="service-name">{{ item?.serviceName | textLimiter : 100 }}</h3>
                        </div>
                        <div class="service-details">
                            <div class="detail-item">
                                <div class="detail-label">{{ "price-info.quantity" | translate }}</div>
                                <div class="detail-value">{{ item?.quantity | textLimiter : 30 }}</div>
                            </div>
                            <div class="detail-item">
                                <div class="detail-label">{{ "price-info.gate-price" | translate }}</div>
                                <div class="detail-value price-value">
                                    {{
                                    item?.gatePrice?.price
                                    | currency
                                    : item?.gatePrice?.currency || ""
                                    : "symbol"
                                    : "1.2-2"
                                    }}
                                </div>
                            </div>
                            <div class="detail-item">
                                <div class="detail-label">{{ "price-info.member-price" | translate }}</div>
                                <div class="detail-value price-value">
                                    {{
                                    item?.memberPrice?.price
                                    | currency
                                    : item?.memberPrice?.currency || ""
                                    : "symbol"
                                    : "1.2-2"
                                    }}
                                </div>
                            </div>
                            <div class="detail-item">
                                <div class="detail-label">{{ "price-info.total" | translate }}</div>
                                <div class="detail-value price-value">
                                    {{
                                    item?.total
                                    | currency
                                    : (item?.memberPrice?.currency ??
                                    item?.gatePrice?.currency) || ""
                                    : "symbol"
                                    : "1.2-2"
                                    }}
                                </div>
                            </div>
                              <i class="pi pi-trash trash-delete-icon" (click)="deleteConfirm(item)"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="
              filterForm.get('services')?.invalid &&
              filterForm.get('services')?.touched
            " class="text-danger">
              <small *ngIf="filterForm.get('services')?.errors?.['required']">{{
                "price-info.at-least-one-service-required" | translate
                }}</small>
            </div>
          </div>

        </app-cards>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-12 mb-2">

        <app-cards [title]="'price-info.others-info' | translate" footerDivider="border-0 pb-0 "
          class="custom-cardbox-area">
          <div bodyContent class="row p-3">
            <!-- Telefon -->
            <div class="col-12 mb-2">
              <label for="notlar" class="form-label"> {{ "price-info.phone-number" | translate }} </label>
              <input
                type="text"
                class="form-control"
                id="type"
                placeholder="xxxxxxxxxx"
                [(ngModel)]="agentPhone"
                (keyup)="onlyAllowNumbers($event)"
                maxlength="10"
              />
            </div>

            <!-- Açıklama -->
            <div class="col-12 mb-3">
              <label for="notlar" class="form-label">{{"price-info.description" | translate }}</label>
              <textarea
              id="notlar"
              class="form-control"
              rows="2"
              [placeholder]="'price-info.description' | translate"
              [(ngModel)]="agentNote"
              maxlength="1200"
              ></textarea>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6 col-sm-12">
                <label for="personNo" class="form-label">{{
                  "medical-advice.personNo" | translate
                  }}</label>
                <app-patient-card (openDetailOn)="onOpenDetail($event)" (selectOn)="onPatientSelect($event)" #patientCard>
                </app-patient-card>
              </div>
            
              <div class="col-xl-6 col-sm-12">
            
                <label class="form-label required-star" for="">
                  {{ "medical-advice.patient-fullname" | translate }}
                </label>
                <input type="text" [disabled]="lockInput" class="form-control"
                  [placeholder]="'medical-advice.patient-fullname-placeholder' | translate" [(ngModel)]="personFullName"
                  (input)="onStringInput($event)" />
            
                <div *ngIf="isSubmit && filterForm.get('personFullName')?.hasError('required')" class="text-danger">
                  <small>{{ "validation.required" | translate }}</small>
                </div>
              </div>
            </div>
            <!-- Sağ tarafa yaslı fiyat alanları -->
            <div class="col-12 d-flex justify-content-end">
              <div class="row w-50">
                <div class="col-12 d-flex justify-content-end">
                  <div class="col-xl-7">
                    <label for="type" class="form-label">{{ "price-info.latest-price" | translate }} </label>

                    <div>
                      <input type="text" class="form-control text-end" id="latestPrice" disabled
                        [value]="calculateTotalPrice | currency : '' : '' : '1.2-2'" />
                    </div>
                  </div>
                </div>
                <div class="col-12 d-flex justify-content-end">
                  <!-- Hastaya iletilen tutar -->
                  <div class="col-xl-7">
                    <label for="type" class="form-label">{{"price-info.price-to-send-patient" | translate }}</label>

                    <div>
                      <p-inputNumber
                        [(ngModel)]="priceToSendPatient"
                        inputId="minmaxfraction"
                        mode="currency"
                        class=" text-end"
                        [currency]="'TRY'"
                        [minFractionDigits]="2"
                        [min]="0"
                        [maxFractionDigits]="2"
                      />
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>

        </app-cards>
      </div>

    </div>
  </div>
</div>

</app-core-offcanvas>

<core-address-autocomplete
  #fromAddressComponent
  (setAddress)="handleSetFromAddress($event)"
>
</core-address-autocomplete>

<core-address-autocomplete
  #toAddressComponent
  (setAddress)="handleSetToAddress($event)"
>
</core-address-autocomplete>

<app-service-price-popup
  (saveOn)="onSaveServices($event)"
  [priceTypeId]="filterForm.controls['priceType']?.value"
  [date]="filterForm.controls['date']?.value"
  #servicePopup
></app-service-price-popup>

<div *ngIf="showDialog">
  <app-patient-create #createPatient></app-patient-create>
</div>
<app-loading [fullScreen]="true" [loading]="loading"></app-loading>


<p-dialog [(visible)]="showSuccessDialog" 
          [modal]="true" 
          [style]="{ width: '400px' }" 
          [showHeader]="false"
          [closable]="false">

  <div class="success-container">
    <h2>{{ caseTypeCode }}-{{ caseNo }}</h2>

    <i class="pi pi-copy pointer mx-2" 
       (click)="copyText()" 
       role="button"
       tabindex="-1">
    </i>

    <div class="copy-notification" [class.show]="showNotification">
      {{ "case.copy" | translate }}
    </div>

    <div class="success-icon-container">
      <i class="pi pi-check-circle success-icon"
         (click)="closeAll()"
         role="button"
         tabindex="-1">
      </i>
    </div>
  </div>

</p-dialog>
